<script>
import baseGridMixin from './BaseGridMixin.vue'
export default {
    mixins: [baseGridMixin],
    data () {
        let data;

        if (this.storedData.is_updated) {
            data = this.storedData.updated;
        } else {
            data = this.storedData.original;
        }

        return {
            value: data,
            isUpdated: this.storedData.is_updated,
            isInvalid: false,
            notApplicable: false
        }
    },
    methods: {
        onKeyEsc: function (event) {
            this.isInvalid = false;
            this.isUpdated = false;
            this.storedData.is_updated = false;
            this.storedData.updated = "";
            this.value = this.storedData.original;
            this.onChange(this.value);
        },
        onKeyEnter: function (event) {
            this.focusNextCell();
        },
        onFocus: function (event) {
            event.target.select();
        },
        onChange: function (event) {
            this.isInvalid = false;
            let cellStateUnchanged = this.determineCellState();
            this.postUpdate(event, cellStateUnchanged);
        },
        determineCellState: function () {
            let cellStateUnchanged = false;

            if (this.value === this.storedData.original) {
                this.isUpdated = false;
                cellStateUnchanged = true;
            } else {
                this.isUpdated = true;
            }

            this.$emit('dataUpdated');

            return cellStateUnchanged;
        },
        isCellUpdated: function () {
            return this.isUpdated;
        }
    },
}
</script>>
